import React, { useState, useEffect, useCallback } from 'react';
import { AdUnit } from './AdUnit';

const AD_SLOT_BETWEEN_VOTES = '5253813406'; // Display – auto format

export function VotingInterface() {
  const [pair, setPair] = useState(null);
  const [loading, setLoading] = useState(true);
  const [voted, setVoted] = useState(false);
  const [error, setError] = useState(null);
  const [voteCount, setVoteCount] = useState(0);

  const fetchPair = useCallback(async () => {
    setLoading(true);
    setError(null);
    setVoted(false);
    try {
      const res = await fetch('https://should-i-get-reparations-backend.vercel.app/api/voting/pair');
      const data = await res.json();
      if (data.success) {
        setPair(data.data);
      } else {
        setError('No photos available to vote on yet. Check back soon!');
        setPair(null);
      }
    } catch (err) {
      console.error('Failed to fetch pair:', err);
      setError('Could not load photos. Please try again.');
      setPair(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPair();
  }, [fetchPair]);

  const handleVote = async (personId) => {
    try {
      const res = await fetch('https://should-i-get-reparations-backend.vercel.app/api/voting/vote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          person_id: personId,
          session_id: 'session-' + Date.now(),
        }),
      });
      const data = await res.json();
      if (data.success) {
        setVoted(true);
        setVoteCount((c) => c + 1);
      }
    } catch (err) {
      console.error('Failed to vote:', err);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
        Loading photos…
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <p style={{ color: '#666', marginBottom: '20px' }}>{error}</p>
        <button onClick={fetchPair} className="vote-button" style={{ width: 'auto', padding: '12px 30px' }}>
          Try Again
        </button>
      </div>
    );
  }

  if (voted) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '3rem', marginBottom: '16px' }}>🗳️</div>
        <h2 style={{ color: '#28a745', marginBottom: '8px' }}>Vote recorded!</h2>
        <p style={{ color: '#666', marginBottom: '8px' }}>
          You've voted {voteCount} time{voteCount !== 1 ? 's' : ''} this session.
        </p>
        <p style={{ color: '#999', fontSize: '0.9rem', marginBottom: '28px' }}>
          Votes help determine who deserves reparations.
        </p>

        {/* Display ad between vote rounds */}
        <AdUnit slot={AD_SLOT_BETWEEN_VOTES} format="auto" fullWidthResponsive={true} />

        <button
          onClick={fetchPair}
          className="vote-button"
          style={{ width: 'auto', padding: '14px 40px', fontSize: '1.1rem' }}
        >
          Vote on Next Pair →
        </button>
      </div>
    );
  }

  return (
    <div className="voting-interface">
      {voteCount > 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '8px', fontSize: '0.95rem' }}>
          Votes cast this session: <strong>{voteCount}</strong>
        </p>
      )}

      <div className="voting-pair">
        {/* Person A */}
        <div className="person-card" onClick={() => handleVote(pair.person1.id)}>
          <img
            src={pair.person1.photo_url}
            alt="Person A"
            className="person-image"
            loading="lazy"
          />
          <div className="person-info">
            <h3>Person A</h3>
            <p className="vote-count">{pair.person1.vote_count} votes</p>
            <button className="vote-button">✓ Vote for This Person</button>
          </div>
        </div>

        <div className="vs-divider">
          <span>VS</span>
        </div>

        {/* Person B */}
        <div className="person-card" onClick={() => handleVote(pair.person2.id)}>
          <img
            src={pair.person2.photo_url}
            alt="Person B"
            className="person-image"
            loading="lazy"
          />
          <div className="person-info">
            <h3>Person B</h3>
            <p className="vote-count">{pair.person2.vote_count} votes</p>
            <button className="vote-button">✓ Vote for This Person</button>
          </div>
        </div>
      </div>
    </div>
  );
}
